import React, { useState } from "react";
// import { IArticle } from "../order/orderDetail";
import { Link } from "react-router-dom";
import Collapse from "../Collapse/Collapse";
import { BsCaretDown, BsCaretUp } from "react-icons/bs";
import ArticleDetail from "./ArticleDetail";
import classNames from "classnames";
import { useSelectedArticleStore } from "../../store/store";
import { Article } from "../../api/order/generated/src";

interface IArticleItemProps {
    article:Article;

    onSelect: (id:string) => void;
    selected: boolean;
}

const ArticleItem = (props:IArticleItemProps) => {
    const { article, selected, onSelect } = props;


    const selectedArticle = useSelectedArticleStore(state => state.article);
    

    const articleSelected = article.id === selectedArticle.id;

    // const [showInfos, setShowInfos] = useState<boolean>(false);

    // const showInfos = selected;
    const showInfos = articleSelected;

    const collapseInfos = true;

    return (
        <>
            <div className="">
                

                <div 
                    className={classNames("gap-4 grid w-full rounded-lg bg-white shadow-lg p-4 mb-4", {"selected-article border border-[green]": articleSelected})}
                    onClick={() => {
                        onSelect(article.id ?? "");
                    }}
                >
                    <div 
                        // className="flex flex-col gap-4 lg:grid lg:grid-cols-[5fr_1fr_1fr]  sm:grid-flow-col"
                        className="flex flex-row gap-4"
                        // onClick={() => {
                        //     setShowInfos(!showInfos);
                        // }}
                    >
                        <div className="grow">
                            <div>
                                {article.externalId}
                            </div>
                            <div>
                                {article.title}
                            </div>
                        </div>

                        <div>
                            <span>{article.quantityBooked} / {article.quantity}</span>
                        </div>
                        <div>
                            <div className="w-full flex justify-end">
                                {showInfos 
                                    ?
                                        <BsCaretUp 
                                            // onClick={() => {
                                            //     setShowInfos(false);
                                            // }}
                                            className="self-end"
                                        />
                                    :
                                        <BsCaretDown 
                                            // onClick={() => {
                                            //     setShowInfos(true);
                                            // }}
                                            className="self-end"
                                        />
                                }
                            </div>
                        </div>
                    </div>

                    <Collapse open={showInfos || !collapseInfos}>
                        <div className="w-full">
                            <div className="pt-4">
                                <ArticleDetail 
                                    // articleId={article.id}
                                    article={article}
                                />  
                            </div>
                        </div>
                    </Collapse>
                </div>




            </div>


            {/* <Link to={`/article/${article.id}`}>
                <div className="gap-4 grid w-full rounded-lg bg-white shadow-lg p-4 mb-4">
                    <div className="flex flex-col gap-4 lg:grid lg:grid-cols-[2fr_2fr_1fr_2fr]  sm:grid-flow-col">
                        {article.title}

                        <div>
                            <span>{article.booked} / {article.ordered}</span>
                        </div>
                    </div>
                </div>
            </Link> */}
        </>
    )
};

export default ArticleItem;
